
import {ChooseSalonDialog} from './Common/CommonComponents';
import {Header } from '../models';

export default {
	components: {
		ChooseSalonDialog
	},
	props: {
		items: {
			type: Array,
			default: function () {
				return [];
			},
		},
		headerProps: {
			type: [Header, Object],
			default: function () {
				return new Header();
			},
		}
	},
	data: () => ({
		isMounted: false,
	}),
	mounted() {
		this.isMounted = true;
	},
	methods: {
		navigationAction(item) {
			this.$emit('navigationAction', item);
			this.closeMenu(); // Explicitly close the menu after a navigation action
		},
		closeMenu(){
            this.$emit('closeMenu')
            this.$emit('closeAndResetAppBar'); // Emit new event to trigger icon reset

		}
	},
	computed: {
		salons() {
			return this.$store.getters['salon/getSalons']
		},
		useConstrastColors() {
			return this.headerProps.layout == 'chain' ? this.$store.getters['cmsConfigHomepage/primaryAndSecondaryAreEqual'] : false
		},
		dropdownItems() {
			return this.items.filter(item => item.Id != 7)
		},
		isDraft() {
			return this.$store.getters['cmsConfigHomepage/isDraftMode']
		},
		bookingSites() {
			if (!(this.$router.currentRoute.path.includes('nettbutikk') || window.location.host.includes('profil.'))) {
				let selectedSalon = this.$store.getters['cart/getSelectedSalon']
				if (selectedSalon) {
					return this.salons.filter(x => x.siteId === selectedSalon);
				} else {
					return this.salons
				}
			} else return this.salons
		}
	}
};
